import { useState } from "react";
import { OrdersListView } from "../components/OrdersListView"
import { Button, ButtonGroup, Stack, TextField } from "@mui/material";

import React, { Component } from 'react'
import debounce from 'lodash/debounce'
import { useParams } from "react-router-dom";
import useCookie from "../helpers/cookie";

export default function debouncedInput(WrappedComponent, config = { timeout: 500 }) {
  return class DebouncedTextField extends Component {
    constructor(props) {
      super(props)
      this.state = {
        value: this.props.value,
      }
      this.sendTextChange = debounce(this.sendTextChange, config.timeout)
    }

    handleTextChange = (e) => {
      this.setState({value: e.target.value});
      this.sendTextChange({ target: { value: e.target.value } })
    };

    sendTextChange = (e) => {
      this.props.onChange(e);
    }

    render() {
      return (
        <WrappedComponent {...this.props} value={this.state.value} onChange={this.handleTextChange.bind(this)} />
      )
    }
  }
}

const DebouncedTextField = debouncedInput(TextField, { timeout: 600 })

const OrdersBrowser = () => {
    const [orderMode, setOrderMode] = useCookie("order_mode", "queue");
    const [statuses, setStatuses] = useCookie("order_statuses", "rush,waiting for shipment,pending shipment");
    const [searchFilter, setSearchFilter] = useState("");
    let filters = {}
    if (searchFilter !== "") {
        if (searchFilter.length === 4) {
            filters["order_id__like"] = searchFilter;
        } else {
            filters["order_id__like"] = `%${searchFilter}%`;
        }
    } else {
        filters["status__in"] = statuses;
    }
    return <Stack sx={{marginTop: 2, marginBottom: 4}} spacing={2}>
            <ButtonGroup>
                <Button variant={orderMode==="draft" ? "contained": "outlined"} onClick={() => {setOrderMode("draft");setStatuses("draft")}}>Drafts</Button>
                <Button variant={orderMode==="queue" ? "contained": "outlined"} onClick={() => {setOrderMode("queue");setStatuses("rush, awaiting payment")}}>Working</Button>
                <Button variant={orderMode==="invoiced" ? "contained": "outlined"} onClick={() => {setOrderMode("invoiced");setStatuses("waiting for shipment,pending shipment")}}>Invoiced</Button>
                <Button variant={orderMode==="shipped" ? "contained": "outlined"} onClick={() => {setOrderMode("shipped");setStatuses("shipped")}}>Completed</Button>
                <DebouncedTextField sx={{marginLeft: 2}} value={searchFilter} placeholder="Type to search..." onChange={(event) => {
                    setSearchFilter(event.target.value);
                }}/>
            </ButtonGroup>
        <OrdersListView filters={filters} />
        </Stack>
}

export { OrdersBrowser };
